import BackIcon from 'assets/images/rectangle/Back_black.svg'
import { useNavigate, useParams } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import CustomDropDown from 'components/dropDown'
import classNames from 'classnames'
import { useState } from 'react'
import CustomBottomSheet from 'components/bottomSheet'
import Share from '../share'
import JoinLink from '../joinLink'
interface IHeaderProps {
    exist: number
    hamyanBalance: number
    bankBalance: string
    inprogress: number
    balance: number
    showBalance: boolean
    poolShipId: number | undefined
    role: string
    setIsOpenExcelModal: React.Dispatch<React.SetStateAction<boolean>>
    isFuckingManager: () => boolean
    name: string
    servicePackage: number
    trustedState: string
}
export default function Header({
    exist,
    hamyanBalance,
    bankBalance,
    inprogress,
    balance,
    showBalance,
    poolShipId,
    role,
    name,
    isFuckingManager,
    setIsOpenExcelModal,
    servicePackage,
    trustedState,
}: IHeaderProps) {
    const [shareBottomSheet, setShareBottomSheet] = useState<boolean>(false)
    const [joinLinkBottomSheet, setJoinLinkBottomSheet] =
        useState<boolean>(false)
    const navigate = useNavigate()
    const { id } = useParams()

    return (
        <>
            <div className=" w-full py-2 bg-white px-2 items-center">
                <div className=" w-full flex justify-between text-center items-center relative">
                    <img
                        src={BackIcon}
                        alt="back-icon"
                        onClick={() => navigate(-1)}
                        className=" cursor-pointer"
                    />
                    <p className=" absolute -top-2 right-10 text-xs bg-yellow-1 py-2 px-3 rounded-b-2xl shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        {servicePackage === 1
                            ? 'اشتراکی'
                            : servicePackage === 2
                            ? 'رایگان'
                            : 'کارمزدی'}
                    </p>
                    {servicePackage !== 2 && (
                        <p className=" absolute -top-2 left-7 bg-green-1 py-2 px-3 rounded-b-2xl shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] w-20 text-white text-xs">
                            {trustedState === 'trst'
                                ? 'متصل به حساب همیان'
                                : 'متصل به حساب مدیر'}
                        </p>
                    )}
                    {showBalance && (
                        <div className=" text-sm text-center">
                            <p className=" text-gray-1 text-xs">موجودی صندوق</p>
                            <div className="flex text-center mt-2 text-sm">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        style={{
                                            backgroundColor: '#ffffff',
                                            border: 'none',
                                            color:
                                                Number(exist) > 0
                                                    ? '#74B743'
                                                    : '#e05e41',
                                            padding: '0px',
                                            // marginRight: '5px',
                                            marginLeft: '50%',
                                            inset: '10px -100% auto auto',
                                        }}
                                    >
                                        <span className=" text-lg">
                                            {exist && exist.toLocaleString()}{' '}
                                            <span
                                                className={classNames(
                                                    Number(exist) > 0
                                                        ? ' text-green-1'
                                                        : 'text-red-1'
                                                )}
                                            ></span>
                                            تومان
                                        </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu
                                        style={{
                                            backgroundColor: '#D3E8EB',
                                            padding: '10px',
                                            width: '230px',
                                            left: '-60% !important',
                                            right: '-60% !important',
                                            inset: '10px -100% auto auto',
                                        }}
                                        id="dropdown-center"
                                    >
                                        <p className=" text-center my-1">
                                            موجودی نزد همیان:
                                        </p>
                                        <p className=" text-center my-1">
                                            {' '}
                                            {hamyanBalance &&
                                                hamyanBalance.toLocaleString()}{' '}
                                            <span>تومان</span>
                                        </p>
                                        <p className=" text-center my-1">
                                            موجودی نزد مدیر:
                                        </p>
                                        <p className=" text-center my-1">
                                            {bankBalance &&
                                                Number(
                                                    bankBalance
                                                ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                        <p className=" text-center my-1">
                                            درحال واریز به حساب صندوق:
                                        </p>
                                        <p className=" text-center my-1">
                                            {inprogress &&
                                                Number(
                                                    inprogress
                                                ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                        <p className=" text-center my-1">
                                            مجموع موجودی:
                                        </p>
                                        <p className=" text-center my-1">
                                            {balance &&
                                                Number(
                                                    balance
                                                ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    )}
                    <div>
                        <CustomDropDown listWrapperClassName="w-[188px] top-4  absolute">
                            <div className=" text-sm text-right px-2">
                                {isFuckingManager() && (
                                    <>
                                        <p
                                            className=" my-2"
                                            onClick={() =>
                                                navigate(`/fund/plans/${id}`, {
                                                    state: {
                                                        name,
                                                        servicePackage,
                                                    },
                                                })
                                            }
                                        >
                                            خرید اشتراک
                                        </p>
                                        <p
                                            className=" my-2"
                                            onClick={() =>
                                                setIsOpenExcelModal(true)
                                            }
                                        >
                                            دریافت اکسل گزارش صندوق
                                        </p>
                                        <p
                                            className=" my-2"
                                            onClick={() =>
                                                navigate(
                                                    `/fund/financial-dashboard/${id}`,
                                                    { state: { name } }
                                                )
                                            }
                                        >
                                            داشبورد هزینه و درآمد
                                        </p>
                                        <p
                                            className=" my-2"
                                            onClick={() =>
                                                setShareBottomSheet(true)
                                            }
                                        >
                                            لینک پرداخت صندوق
                                        </p>
                                        <p
                                            className=" my-2"
                                            onClick={() =>
                                                navigate(`/fund/setting/${id}`)
                                            }
                                        >
                                            تنظیمات صندوق
                                        </p>
                                        <p
                                            className=" my-2"
                                            onClick={() =>
                                                setJoinLinkBottomSheet(true)
                                            }
                                        >
                                            لینک عضویت در صندوق
                                        </p>
                                    </>
                                )}
                                <p
                                    className=" my-2"
                                    onClick={() => {
                                        isFuckingManager()
                                            ? navigate(
                                                  `/fund/admin-settlement-exit/${id}`
                                              )
                                            : navigate(
                                                  `/fund/settlement-exit/${id}`,
                                                  { state: { poolShipId } }
                                              )
                                    }}
                                >
                                    {isFuckingManager()
                                        ? 'درخواست های تسویه و خروج'
                                        : 'درخواست تسویه و خروج'}
                                </p>
                            </div>
                        </CustomDropDown>
                    </div>
                </div>
            </div>
            <hr className=" text-gray-4 " />
            <CustomBottomSheet
                isOpen={shareBottomSheet}
                onDismiss={() => setShareBottomSheet(false)}
            >
                <Share />
            </CustomBottomSheet>
            <CustomBottomSheet
                isOpen={joinLinkBottomSheet}
                onDismiss={() => setJoinLinkBottomSheet(false)}
            >
                <JoinLink />
            </CustomBottomSheet>
        </>
    )
}
